import {SET_ROUTER_HISTORY} from "../constants";

const initialState = [];
const router = (state = initialState, action) => {
    switch (action.type) {
        case SET_ROUTER_HISTORY:
            return action.payload;
        default:
            return state;
    }
};

export default router;
